define('../app/fukit/configuration/storage.configuration',['require','exports','module','underscore','evicommon/storage/cookie.storage'],function(require, exports, module) {
  //prettier-ignore
  var _ = require('underscore'),
      StorageHelper = require('evicommon/storage/cookie.storage');

  var StorageConfiguration = {
    radioRequests: {
      'storageConfiguration storage': 'storage',
    },

    radioEvents: {
      'app configure': 'onAppConfigure',
    },

    storage: new StorageHelper().load(),

    onAppConfigure: function(app) {
      app.storage = this.storage;
    },
  };
  module.exports = StorageConfiguration;
});

